import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTimeUtility } from '@core/utils';

@Pipe({
  name: 'weekday',
  standalone: true,
})
export class WeekdayPipe implements PipeTransform {
  private readonly _translate = inject(TranslateService);

  transform(value: number | string): string {
    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const weekdayNumber = isNaN(+value) ? DateTimeUtility.convertWeekdayNameToNumber(value.toString()) : value;
    const day = weekdays[+weekdayNumber];
    return this._translate.instant(day);
  }
}
